import React from "react";
import { Tag, Typography } from "antd";
import {
  RiskIndicator,
  ValidationGap,
} from "../../../../Service/application.insight.service";

const getRiskCardTheme = (risk: RiskIndicator) => {
  if (risk.severity === "high") return { cardClass: "border-card-danger", tag: "red" };
  if (risk.severity === "medium") return { cardClass: "border-card-warning", tag: "yellow" };
  return { cardClass: "border-card-low", tag: "green" };
};

const ValidationGapCard = ({ gap }: { gap: ValidationGap }) => (
  <div className="risk-card gap-card">
    <div className="risk-card-header">
      <Typography.Text strong>{gap.skill}</Typography.Text>
    </div>
    <Typography.Text type="secondary" style={{ fontStyle: "italic" }}>
      {gap.reason}
    </Typography.Text>
  </div>
);

const RiskCard = ({ risk }: { risk: RiskIndicator }) => {
  const { cardClass, tag } = getRiskCardTheme(risk);
  return (
    <div className={`risk-card ${cardClass}`}>
      <div className="risk-card-header">
        <Typography.Text strong>{risk.type}</Typography.Text>
        <Tag color={tag}>{risk.severity}</Tag>
      </div>
      <Typography.Text type="secondary" style={{ fontStyle: "italic" }}>
        {risk.description}
      </Typography.Text>
    </div>
  );
};

interface RiskAndGapsBlockProps {
  validationGaps: ValidationGap[];
  riskIndicators: RiskIndicator[];
}

const RiskAndGapsBlock: React.FC<RiskAndGapsBlockProps> = ({ validationGaps, riskIndicators }) => (
  <div className="aic-skill-match">
    {validationGaps.length > 0 && (
      <div>
        <div className="aic-header-title">
          <span
            className="material-symbols-outlined"
            data-icon="warning"
            style={{ color: "#f59e0b", fontSize: "16px" }}
          >
            warning
          </span>
          <Typography.Text type="warning" strong>
            VALIDATION GAPS
          </Typography.Text>
        </div>
        <Typography.Text>
          Skills that could not be verified from resume alone
        </Typography.Text>
        <div className="skill-card-wrapper">
          {validationGaps.map((g, i) => (
            <ValidationGapCard key={i} gap={g} />
          ))}
        </div>
      </div>
    )}
    {riskIndicators.length > 0 && (
      <div>
        <div className="aic-header-title">
          <span
            className="material-symbols-outlined"
            data-icon="release_alert"
            style={{ color: "#FF4D4F", fontSize: "16px" }}
          >
            release_alert
          </span>
          <Typography.Text type="danger" strong>
            RISK INDICATORS
          </Typography.Text>
        </div>
        <Typography.Text>
          Signals that may affect hiring decision
        </Typography.Text>
        <div className="skill-card-wrapper">
          {riskIndicators.map((r, i) => (
            <RiskCard risk={r} key={i} />
          ))}
        </div>
      </div>
    )}
  </div>
);

export default RiskAndGapsBlock;
